import { render, staticRenderFns } from "./UnpaginatedList.vue?vue&type=template&id=0fe24023&scoped=true&"
import script from "./UnpaginatedList.vue?vue&type=script&lang=js&"
export * from "./UnpaginatedList.vue?vue&type=script&lang=js&"
import style0 from "./UnpaginatedList.vue?vue&type=style&index=0&id=0fe24023&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe24023",
  null
  
)

export default component.exports